import React from "react";

interface TimeWheelProps {
  value: number;
  max: number;
  onChange: (v: number) => void;
}

export function TimeWheel({ value, max, onChange }: TimeWheelProps) {
  const getPrevValue = (v: number) => (v > 0 ? v - 1 : max);
  const getNextValue = (v: number) => (v < max ? v + 1 : 0);

  const prevValue = getPrevValue(value);
  const nextValue = getNextValue(value);

  const handleWheel = (e: React.WheelEvent) => {
    e.preventDefault();
    if (e.deltaY < 0) {
      onChange(getPrevValue(value));
    } else {
      onChange(getNextValue(value));
    }
  };

  return (
    <div
      className="flex flex-col items-center flex-1 min-w-px"
      onWheel={handleWheel}
    >
      <div className="w-full flex flex-col items-center">
        {/* Previous value - clickable */}
        <button
          onClick={() => onChange(prevValue)}
          className="h-[48px] flex items-center justify-center border-b border-neutral-light/20 w-full cursor-pointer transition-all duration-200 hover:bg-neutral/5"
        >
          <span className="text-[18px] text-[#8D8D8D] font-normal">
            {String(prevValue).padStart(2, "0")}
          </span>
        </button>
        {/* Current value - highlighted */}
        <div className="h-[48px] flex items-center justify-center border-b border-neutral-light/20 w-full">
          <span className="text-[18px] text-[#000000] font-bold">
            {String(value).padStart(2, "0")}
          </span>
        </div>
        {/* Next value - clickable */}
        <button
          onClick={() => onChange(nextValue)}
          className="h-[48px] flex items-center justify-center w-full cursor-pointer transition-all duration-200 hover:bg-neutral/5"
        >
          <span className="text-[18px] text-[#8D8D8D] font-normal">
            {String(nextValue).padStart(2, "0")}
          </span>
        </button>
      </div>
    </div>
  );
}
